import React from 'react';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ProgressSpinner
  from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import styles from '../../../guidance/tags/modals/TagDetailsModal/TagDetailsModal.module.css';
import useBulkDeleteAlert from '../useBulkDeleteAlert';

/* istanbul ignore next */
function BulkDeleteAlertModal(props) {
  const {
    alertList,
    onClose,
    onDelete,
  } = props;

  const { bulkDelete, submitting, submitted } = useBulkDeleteAlert();

  const alertIdList = alertList.map((alert) => alert.id);

  if (submitted) {
    onClose();
  }

  return (
    <>
      <Modal
        show
        onHide={onClose}
        animation={false}
      >
        <Modal.Header>
          <div className="mx-auto text-center">
            <h3>
              Delete
            </h3>
          </div>
        </Modal.Header>
        <Modal.Body>
          <>
            <div className="mb-2">
              Are you sure you want to delete
              {' '}
              {alertList.length}
              {' '}
              alerts?
            </div>
            <div className={styles.tagContainer}>
              {
                  alertList.length > 0
                  && alertList
                    .map((alert) => (
                      <div className="d-flex flex-row">
                        <div className="text-center">
                          <span>{alert.description}</span>
                        </div>
                      </div>
                    ))
              }
            </div>
          </>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col ml-auto">
              <Button
                variant="secondary"
                onClick={onClose}
              >
                Cancel
              </Button>
              {' '}
              <Button
                variant="primary"
                onClick={() => bulkDelete(alertIdList, onDelete)}
                disabled={submitting}
              >
                {submitting
                  ? (
                    <div className="row mx-1 d-flex justify-content-center">
                      <ProgressSpinner useSmallSpinner progressText="" />
                      Deleting...
                    </div>
                  )
                  : (<>Delete</>)}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

BulkDeleteAlertModal.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  alertList: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default BulkDeleteAlertModal;
